import { Dialog, DialogContent, DialogTitle, Tooltip } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

// Import Material UI
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

// Import CSS
import "./FullScreen.css";
import { Close } from '@material-ui/icons';

const FullScreen = ({ title, description, item, handleClose, children, type, label }) => {
    const { t } = useTranslation();
    const [rowCount, setRowCount] = useState(null)
    const [columnCount, setColumnCount] = useState(null)
    const [limit, setLimit] = useState(null)

    useEffect(() => {
        checkValue(item.value, item.cantParse)
    }, [])

    const checkValue = (value, cantParse) => {
        const logOutput = cantParse ? value : JSON.parse(value) ? JSON.parse(value) : value;
        if (logOutput) {
            if (logOutput.total_column_count) {
                setColumnCount(logOutput.total_column_count)
            }
            if (logOutput.total_row_count) {
                setRowCount(logOutput.total_row_count)
            }
            if (logOutput.limit) {
                setLimit(logOutput.limit)
            }
        }
        return false
    }

    return (
        <Dialog
            id="au-fullscreen-dialog"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    // minWidth: "95%",
                    width: "70%",
                    // height: "90%",
                    height: "90%",
                    borderRadius: " 4px",
                    // padding: "4px 22px",
                    padding: "20px",
                    flexDirection: "column",
                    maxHeight: "none",
                    maxWidth: "none",
                    gap: "10px",
                    // overflow: "hidden"
                },
            }}
        >
            <div id='au-fullscreen-title-container'>
                <div>
                    {title ? <h4 className="au-fullscreen-title">{title}</h4> : ""}
                    {description ? <small
                        className="au-fullscreen-title-desc"><em>{description}</em></small> : ""}
                </div>
                <Close className="autom-group-close-button logs-close-icon" onClick={handleClose} style={{ fontSize: "1rem" }} />
            </div>
            {type && type === "data table"
                ? <div className='data-table-fullscreen-container-container' style={{ display: "flex" }}>
                    <DialogContent className={`au-fullscreen-content-container`}>
                        {children ? children : ""}
                    </DialogContent>
                    {item && columnCount ?
                        <Tooltip placement='top' title={`Displaying ${limit} of ${columnCount} rows.`}>
                            <MoreHorizIcon style={{ alignSelf: "center" }} />
                        </Tooltip>
                        : ""}
                </div>
                : <DialogContent className={`au-fullscreen-content-container`}>
                    {children ? children : ""}
                </DialogContent>}
            {type && type === "data table" && rowCount ?
                <Tooltip placement='top' title={`Displaying ${limit} of ${rowCount} rows.`}>
                    <MoreVertIcon style={{ alignSelf: "center" }} />
                </Tooltip>
                : ""}
        </Dialog >
    )
}

export default FullScreen